import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { configuration } from 'src/environments/environment';

@Component({
  selector: 'app-tasksand-messages',
  templateUrl: './tasksand-messages.component.html',
  styleUrls: ['./tasksand-messages.component.css']
})
export class TasksandMessagesComponent implements OnInit {

  IsMessengerPatient: boolean = false;
  IsMessengerStaff: boolean = false;
  IsPatientMessages: boolean = true;
  IsTasks: boolean = true;
  activetabcat = 0;
  isdirecttab: any = false;
  constructor(router: Router, private route1: ActivatedRoute, private crypto: AESAlgorithm) {
    if (sessionStorage.getItem("isdirect").toString() == 'true')
      this.isdirect = true;
    this.route1.queryParams.subscribe(params => {
      this.isdirecttab = this.crypto.urlParmeterDecoder(decodeURIComponent(params['fromDirect']));
    });
  }

  ngOnInit() {
    var dashboardname = this.route1.snapshot.paramMap.get('screen');
    if (dashboardname == 'BackToMessages') {
      this.IsPatientMessages = true;
      this.IsTasks = true;
      this.activetabcat = 2;
      sessionStorage.setItem("TaskMessage", "false")
      this.taskTab = false;
      this.directTab = false;
      this.messageinboxTab = true;
      this.intstaffTab = false;
      this.MessengerPatientTab = false;
    } else {
      if (this.isdirecttab != "true")
        this.taskTab = true;
      else {
        this.activetabcat = 1;
        this.directTab = true;
      }
    }




    this.IsMessengerPatient = configuration.IsEnableTelemedicine;
    this.IsMessengerStaff = configuration.IsEnableTelemedicine;
    // this.taskTab = true;
    // alert(window.location.pathname);
  }

  isopenTab = ''
  isdirect: boolean = false;


  taskTab: boolean = false;
  directTab: boolean = false;
  messageinboxTab: boolean = false;
  intstaffTab: boolean = false;
  MessengerPatientTab: boolean = false


  tabevnt;
  ontabClick(event) {
    this.tabevnt = event;
    sessionStorage.setItem("TaskMessage", "false")
    if (this.tabevnt.index == 0) {
      this.taskTab = true;
      this.directTab = false;
      this.messageinboxTab = false;
      this.intstaffTab = false;
      this.MessengerPatientTab = false;
      sessionStorage.setItem("TaskMessage", "true")
      this.activetabcat = 0;
    }

    else if (this.tabevnt.index == 1) {

      this.taskTab = false;
      this.directTab = true;
      this.messageinboxTab = false;
      this.intstaffTab = false
      this.MessengerPatientTab = false;

    }
    else if (this.tabevnt.index == 2) {

      this.taskTab = false;
      this.directTab = false;
      this.messageinboxTab = true;
      this.intstaffTab = false;
      this.MessengerPatientTab = false;


    }

    else if (this.tabevnt.index == 3) {

      this.taskTab = false;
      this.directTab = false;
      this.messageinboxTab = false;
      this.intstaffTab = true;
      this.MessengerPatientTab = false;

    }

    else if (this.tabevnt.index == 4) {

      this.taskTab = false;
      this.directTab = false;
      this.messageinboxTab = false;
      this.intstaffTab = false;
      this.MessengerPatientTab = true;
    }

  }
}
